'use client'

import { useEffect, useState } from 'react'

// value が true のまま delayMs 経過したら true になるフラグを返す。
// value が false に戻ったら即座に false へリセットする。
// 入力途中でバリデーションが有効⇔無効を行き来する際のUIチラつき防止に使う。
export const useStableFlag = (value: boolean, delayMs = 500): boolean => {
    const [stable, setStable] = useState(false)

    useEffect(() => {
        if (!value) {
            setStable(false)
            return
        }
        const timer = setTimeout(() => setStable(true), delayMs)
        return () => clearTimeout(timer)
    }, [value, delayMs])

    return stable
}
